// Mock data for Aditya Narayan's Portfolio - Ghost of Tsushima Theme

export const personalInfo = {
  name: "Aditya Narayan",
  title: "Versatile Software Engineer",
  tagline: "Master of Code • Guardian of Systems • Architect of Innovation",
  location: "Delhi, India",
  phone: "+91-7355848551",
  email: "aditya89505@gmail.com",
  linkedin: "linkedin.com/in/aditya-narayan-a32351191",
  github: "github.com/Adi202001",
  summary: "Versatile Software Engineer with comprehensive expertise spanning full-stack development, AI/ML, cybersecurity, and DevOps. Proven track record in building scalable enterprise systems, implementing security automation, and developing AI-powered applications. Proficient in Python, JavaScript, TypeScript, React, Node.js, and cloud technologies including AWS, Docker, and Kubernetes. AWS Certified professional with strong foundation in agile methodologies, team leadership, and cross-functional collaboration.",
  availability: "Immediate",
  repositories: 69,
  languages: ["English (Fluent)", "Hindi (Native)"]
};

export const skills = {
  programming: {
    title: "Programming Arts",
    icon: "Code",
    items: ["Python", "JavaScript", "TypeScript", "HTML", "CSS", "SQL", "Shell Scripting", "Git"]
  },
  frontend: {
    title: "Frontend Mastery",
    icon: "Layout",
    items: ["React", "React Native", "Next.js", "Tailwind CSS", "Redux", "Responsive Design"]
  },
  backend: {
    title: "Backend Fortress",
    icon: "Server",
    items: ["Node.js", "Express.js", "Django", "FastAPI", "Flask", "GraphQL", "REST APIs", "Microservices"]
  },
  aiml: {
    title: "AI/ML Wisdom",
    icon: "Brain",
    items: ["TensorFlow", "PyTorch", "LangChain", "RAG", "LLM Fine-tuning", "NLP", "Computer Vision", "YOLOv8", "OpenCV"]
  },
  databases: {
    title: "Data Sanctuaries",
    icon: "Database",
    items: ["PostgreSQL", "MongoDB", "Redis", "Elasticsearch", "Firebase", "ChromaDB"]
  },
  devops: {
    title: "DevOps & Cloud",
    icon: "Cloud",
    items: ["AWS (EC2, S3, Lambda, RDS)", "Docker", "Kubernetes", "CI/CD", "GitHub Actions", "Jenkins", "Terraform", "Linux"]
  },
  security: {
    title: "Security Guard",
    icon: "Shield",
    items: ["SIEM", "Penetration Testing", "Vulnerability Assessment", "Network Security", "OWASP", "Incident Response"]
  }
};

export const experiences = [
  {
    id: 1,
    company: "Keplix",
    role: "Head of Technology",
    period: "Jun 2025 - Present",
    type: "current",
    description: [
      "Lead all technical operations, architecture decisions, security infrastructure, and DevOps practices for automotive marketplace platform.",
      "Architected scalable microservices platform using GraphQL, REST APIs, PostgreSQL, Redis, and AWS handling 10K+ daily transactions.",
      "Implemented CI/CD pipelines using Docker, Kubernetes, GitHub Actions reducing deployment time by 60% and downtime by 40%.",
      "Built real-time threat detection and SIEM system using Python, AWS Lambda, and Elasticsearch for security monitoring.",
      "Promoted from intern based on exceptional technical contributions and demonstrated leadership capabilities."
    ]
  },
  {
    id: 2,
    company: "Keplix",
    role: "Full-Stack Developer Intern",
    period: "Jun 2024 - Aug 2024",
    type: "past",
    description: [
      "Developed core platform features using React Native, Next.js, Django, Python, and PostgreSQL increasing user engagement by 45%.",
      "Designed and implemented RESTful APIs, wrote unit tests using Jest and Pytest, managed code with Git and GitHub.",
      "Demonstrated strong problem-solving skills and cross-functional collaboration leading to full-time offer and rapid promotion."
    ]
  },
  {
    id: 3,
    company: "Vijeta Classes",
    role: "Project Manager",
    period: "Aug 2020 - Jan 2021",
    type: "past",
    description: [
      "Managed cross-functional teams using Agile and Scrum methodologies delivering EdTech solutions with 35% improved timelines."
    ]
  },
  {
    id: 4,
    company: "Certcube Labs",
    role: "Cybersecurity Intern",
    period: "Sep 2019 - Nov 2019",
    type: "past",
    description: [
      "Completed training in ethical hacking, penetration testing, vulnerability assessment; earned CEH certification."
    ]
  }
];

export const projects = [
  {
    id: 1,
    name: "Trinetra SIEM",
    subtitle: "The All-Seeing Eye of Security",
    description: "Enterprise-grade Security Information and Event Management system for real-time threat detection, log analysis, and incident response automation.",
    tech: ["Python", "Elasticsearch", "React", "AWS"],
    category: "Security",
    github: "https://github.com/Adi202001/Trinetra-SIEM"
  },
  {
    id: 2,
    name: "FileRAG",
    subtitle: "Document Intelligence Gateway",
    description: "Advanced RAG (Retrieval-Augmented Generation) system for intelligent document processing, semantic search, and context-aware question answering.",
    tech: ["LangChain", "ChromaDB", "Python", "FastAPI"],
    category: "AI/ML",
    github: "https://github.com/Adi202001/fileRAG"
  },
  {
    id: 3,
    name: "JobZoom",
    subtitle: "The Path to Career Victory",
    description: "Multi-Agent Job Application Automation System leveraging AI to streamline job search, application tracking, and interview preparation.",
    tech: ["Python", "LangChain", "CrewAI", "Automation"],
    category: "AI/ML",
    github: "https://github.com/Adi202001/jobzoom"
  },
  {
    id: 4,
    name: "Kanso AI",
    subtitle: "Minimalist Travel Wisdom",
    description: "Kanso (簡素) - World-class AI-driven travel planning platform designed around Japanese Minimalism principles for curated, personalized journeys.",
    tech: ["React", "AI", "Next.js", "TailwindCSS"],
    category: "Full-Stack",
    github: "https://github.com/Adi202001/kanso-AI"
  },
  {
    id: 5,
    name: "PHISHGUARD-AI",
    subtitle: "Guardian Against Digital Deception",
    description: "AI-powered threat detection system using advanced machine learning and deep learning for real-time malware classification and phishing prevention.",
    tech: ["Python", "TensorFlow", "Deep Learning", "ML"],
    category: "Security",
    github: "https://github.com/Adi202001/PHISHGUARD-AI"
  }
];

export const education = {
  degree: "Bachelor of Technology (B.Tech)",
  field: "Cyber Security and Computer Forensics",
  university: "University of Petroleum and Energy Studies (UPES)",
  location: "Dehradun, India",
  period: "Sep 2021 - Nov 2025"
};

export const certifications = [
  { name: "AWS Cloud Practitioner Essential", issuer: "Amazon Web Services" },
  { name: "Certcube Certified Ethical Hacker (CEH)", issuer: "Certcube Labs" },
  { name: "Software Engineering and Agile Development", issuer: "Infosys" },
  { name: "Generative AI Workshop", issuer: "Instabase" },
  { name: "Cisco LABS", issuer: "EC-Council" },
  { name: "Digital Forensics Essentials", issuer: "EC-Council" },
  { name: "Linux Crash Course For Beginners", issuer: "EC-Council" },
  { name: "Foundations of Cybersecurity", issuer: "Google - Coursera" }
];
